var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHomeV2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.62466 10.8751L14.4997 2.41675L25.3747 10.8751V24.1667C25.3747 24.8077 25.1201 25.4224 24.6668 25.8756C24.2136 26.3288 23.5989 26.5834 22.958 26.5834H6.04133C5.40039 26.5834 4.7857 26.3288 4.33249 25.8756C3.87928 25.4224 3.62466 24.8077 3.62466 24.1667V10.8751Z",
    stroke: "white",
    strokeWidth: 1.99832,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHomeV2);
export default __webpack_public_path__ + "static/media/home-v2.36c5ad6c558430b28752328000264a2d.svg";
export { ForwardRef as ReactComponent };